<template>
  <div class="uni-answerSheet">
    <!-- 工具栏 -->
    <div class="settings">
      <div class="top">
        <i class="iconfont iconSettingscontroloptions"></i>
        <span>工具栏</span>
      </div>
      <div class="content">
        <em></em>
        <div class="set" @click="openCalculate">
          <i class="iconfont iconhaofangtuo400iconfontjisuanqi"></i>
          <p>计算器</p>
        </div>
        <el-popover placement="bottom" width="80" trigger="click">
          <ul class="uni-font-change">
            <li
              v-for="item in fontSize"
              :key="item.name"
              @click="fontChange(item.value)"
              class="item"
              :class="fontClass == item.value ? 'active' : ''"
            >
              {{ item.name }}
            </li>
          </ul>

          <div slot="reference" class="set">
            <i class="iconfont iconWord"></i>
            <p>字体</p>
          </div>
        </el-popover>
      </div>
    </div>

    <!-- 倒计时 -->
    <!-- <div class="settings" v-if="showTime">
      <div class="top">
        <i class="iconfont iconnaozhong"></i>
        <span>倒计时</span>
      </div>
      <div class="content">
        <em></em>
        <span class="mal30 mar20 black">用时:</span>
        <span class="f18 oringe">02:30:00</span>
      </div>
    </div> -->
    <div class="settings" v-if="showTime">
      <p class="top">
        <i class="iconfont iconnaozhong"></i>倒计时
      </p>
      <div class="sheetSetCen">
        <div class="content">
        <em></em>
        <span class="mal30 mar20 black">剩余时间:</span>
        <span class="f18 oringe">{{endDate}}</span>
      </div>
      </div>
    </div>

    <!-- 答题卡 -->
    <div class="topic">
      <div class="title">
        <i class="iconfont icondatiqia"></i>
        <span class="active">答题卡</span>
        <span>{{ done.length }}/{{ total }}</span>
      </div>

      <div class="content">
        <div class="main" v-for="(item, key) in datas" :key="key">
          <div class="header">
            <em></em>
            <span>{{ item.question_title }}</span>
            <span>(共{{ item.list.length }}题,共{{ item.fraction }}分)</span>
          </div>
          <ul>
            <li
              v-for="(item2, index) in item.list"
              :key="index"
              :class="
                isAnalysis || topicLx
                  ? toggleClass(item2.make_status)
                  : toggleClass(item2.is_make)
              "
              @click="jump(item2.sort)"
            >
              {{ item2.sort }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="tagging">
      <ul>
        <li v-for="(item, index) in labelList" :key="index">
          <em :class="item.class"></em>
          <span>{{ item.name }}</span>
        </li>
      </ul>
      <div class="submit">
        <div @click="submit">{{ isAnalysis ? "退出" : "提交" }}</div>
        <!--        <div @click="isRouterGo" style="margin-left: 10px" v-if="topicLx">-->
        <!--          {{ isAnalysis ? '保存并退出' : '再做一次' }}-->
        <!--        </div>-->
      </div>
    </div>

    <!-- 计算器 -->
    <div class="calculate">
      <el-drawer
        title="我是标题"
        :visible.sync="calculateDialog"
        :with-header="false"
      >
        <calculate />
      </el-drawer>
    </div>
  </div>
</template>
<script>
import calculate from "./componentCaculate";
import { mapMutations, mapState } from "vuex";
// import { getPaperSetting } from "@/api/realTest";
export default {
  name: "uni-answerSheet",
  computed: {
    ...mapState("common", {
      fontClass: (state) => state.fontClass,
    }),
  },
  components: {
    calculate,
  },
  props: {
    // 题目详情
    datas: {
      type: Array,
      default: () => [],
    },
    // 当前题目id
    currentId: {
      type: Number,
      default: 0,
    },
    // 是否是查看解析页面
    isAnalysis: {
      type: Boolean,
      default: false,
    },
    total: {
      //题目总数
      type: Number,
      default: 0,
    },
    // 是否显示倒计时
    showTime: {
      type: Boolean,
      default: false,
    },
    // 结束时间
    timeDate: {
      type: String,
      default: '0',
    },
    // 智能题型练习
    topicLx: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chooseDoNum: null,
      done: [], //已做题数
      calculateDialog: false,
      start: this.$route.query.start,
      question_style: this.$route.query.question_style,
      // topicListData: [
      //   { name: "来自章节练习", activeName: "lian_xi,zuo_ye" },
      //   { name: "来自试卷练习", activeName: "shi_juan" },
      // ],
      labelList: [
        { name: "已做", class: "active" },
        { name: "未做", class: "" },
        { name: "部分正确", class: "" },
        { name: "未阅", class: "" },
      ],
      fontSize: [
        {
          name: "大",
          value: "uni-large",
        },
        {
          name: "中",
          value: "uni-middle",
        },
        {
          name: "小",
          value: "uni-small",
        },
      ],

      endDate: "00:00:00",  //倒计时
      isTimes: "",  //倒计时 定时器
    };
  },
  watch: {
    datas: {
      handler(v) {
        this.getDones();
      },
      deep: true,
    },
    endDate: {
      handler(v) {
        if(v === '00:00:00'){
          this.$emit("forcedSubmit");
          clearInterval(this.isTimes);
        }
        
      },
    },
  },
  created(){
    if(this.showTime){
      this.countTime();  //倒计时
    }
  },
  mounted() {
    // 答题卡状态(做题/解析)
    this.labelList =
      this.isAnalysis || this.topicLx
        ? [
            { name: "正确", class: "success" },
            { name: "错误", class: "error" },
            { name: "部分正确", class: "partiallyCorrect" },
            { name: "已做", class: "active" },
            { name: "未做", class: "unread" },
          ]
        : [
            { name: "已做", class: "active" },
            { name: "未做", class: "" },
          ];
  },
  methods: {
    ...mapMutations("common", ["changeFont"]),
    /**
     * 获取试卷设置(主观题选做设置)
     */
    // async getPaperSetting() {
    //   const params = {
    //     paperUuid: this.$route.query.paperUuid,
    //   };
    //   const res = await getPaperSetting(params);
    //   if (res) {
    //     this.chooseDoNum = res.chooseDoNum;
    //   }
    // },
    getDones() {
      this.done = [];
      this.datas.forEach((val) => {
        val.list.forEach((valTo) => {
          if (valTo.is_make === 1) {
            this.done.push(valTo.sort);
          }
        });
      });
    },
    // 倒计时
    countTime() {
      //获取当前时间
      let date = new Date();
      let now = date.getTime();
      //设置截止时间
      let endDate = new Date(this.timeDate);
      let end = endDate.getTime();
      //时间差
      let leftTime = end - now;
      //定义变量h,m,s保存倒计时的时间
      let h, m, s;
      if (leftTime >= 0) {
        h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        m = Math.floor((leftTime / 1000 / 60) % 60);
        s = Math.floor((leftTime / 1000) % 60);
        this.endDate = `${h > 9 ? h : "0" + h}:${m > 9 ? m : "0" + m}:${
          s > 9 ? s : "0" + s
        }`;
      }
      this.isTimes = setTimeout(this.countTime, 1000);
    },
    // 答题卡状态
    toggleClass(status) {
      switch (status) {
        case 1: //已做
          if (this.isAnalysis || this.topicLx) {
            return "success";
          } else {
            return "active";
          }
        case 0: //未做
          return "";
        case 2: //错误
          return "error";
        case 3: //部分正确
          return "partiallyCorrect";
        case 4: //部分正确
          return "active";
        case "unread": //未阅
          return "unread";
        default:
          return "";
      }
    },
    // 打开计算器
    openCalculate() {
      this.calculateDialog = true;
    },
    // 提交
    submit() {
      this.$emit("submit");
    },
    // 点击答题卡跳转到对应题目
    jump(sort) {
      this.$emit("isEmpty");
      this.$emit("change", sort);
    },
    isRouterGo() {
      this.$router.go(-1);
    },
    // 字体切换
    fontChange(val) {
      this.changeFont(val);
    },
  },
};
</script>

<style lang="scss">
.uni-font-change {
  .item {
    cursor: pointer;
    text-align: center;

    &.active,
    &:hover {
      @include fontColor("primary");
    }
  }
}
</style>
<style lang="scss" scoped>
.uni-answerSheet {
  width: 333px;
  background-color: #f8f8f8;
  padding: 0 20px 20px 0;
  // height: $contentH;
  height: 100vh;
  display: flex;
  flex-direction: column;

  .settings {
    .top {
      font-size: 18px;
      display: flex;
      align-items: center;
      padding-top: 20px;

      span {
        color: #343434;
        font-weight: 500;
      }

      i {
        @include fontColor("primary");
        font-size: 24px;
        margin: 0 10px;
      }
    }

    .content {
      display: flex;
      height: 86px;
      align-items: center;
      background: #fff;
      color: #9a9a9a;
      margin-top: 20px;

      em {
        width: 4px;
        height: 22px;
        @include bgColor("primary");
        border-radius: 2px;
      }

      .iconfont {
        font-size: 40px;
      }

      .set {
        text-align: center;
        margin-left: 70px;
      }
    }
  }

  .topic {
    flex: 1;
    margin-top: 30px;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .title {
      display: flex;
      align-items: center;
      padding: 20px 0 0 10px;

      i {
        font-size: 18px;
        @include fontColor("primary");
      }

      span {
        font-size: 18px;
        color: #343434;

        &:last-child {
          color: #f38829;
        }

        &.active {
          margin: 0 10px;
        }
      }
    }

    .content {
      flex: 1;
      overflow-y: scroll;
      overflow-x: hidden;
      margin-top: 20px;
      &::-webkit-scrollbar {
        @include uni-hidden;
      }
    }

    .main {
      .header {
        display: flex;
        margin-bottom: 10px;
        em {
          width: 3px;
          height: 22px;
          @include bgColor("primary");
          border-radius: 1.5px;
          margin-right: 15px;
        }

        span {
          font-size: 12px;
          color: #666666;
        }
      }

      ul {
        display: flex;
        flex-wrap: wrap;
        margin: 0 20px;

        li {
          cursor: pointer;
          width: 24px;
          height: 24px;
          border-radius: 3px;
          background-color: #ebedf4;
          font-size: 12px;
          margin-right: 10px;
          margin-bottom: 10px;
          @include uni-center;
          color: #666666;
          transition: all 0.3s ease-in-out;

          &.active {
            background-color: $primary;
            color: #ffffff;
          }

          &.error {
            background-color: #e64040;
            color: #ffffff;
          }

          &.success {
            background-color: #0ca850;
            color: #ffffff;
          }

          &.partiallyCorrect {
            background-color: #eca722;
            color: #ffffff;
          }

          &.unread {
            background-color: #aaa;
            color: #fff;
          }

          // &:hover,
          &.current {
            box-shadow: 4px 4px 8px #666;
            text-decoration: underline;
          }
        }
      }
    }
  }

  .tagging {
    ul {
      padding: 20px 0 20px 20px;
      // @include uni-center;
      display: flex;
      flex-wrap: wrap;
      li {
        width: 50%;
        margin-bottom: 10px;
        // @include uni-center;

        span {
          display: inline-block;
          min-width: 60px;
          font-size: 14px;
          color: #666666;
        }

        em {
          display: inline-block;
          width: 14px;
          height: 14px;
          border: 1px solid #969696;
          border-radius: 2px;
          margin-right: 5px;

          &.success {
            background-color: #0ca850;
            border: none;
          }

          &.error {
            background-color: #e64040;
            border: none;
          }

          &.active {
            background-color: $primary;
            border: none;
          }
          &.partiallyCorrect {
            background-color: #eca722;
            border: none;
          }
          &.unread {
            background-color: #aaa;
            border: none;
          }
        }
      }
    }

    .submit {
      padding-bottom: 30px;
      @include uni-center;

      div {
        @include uni-button;
      }
    }
  }

  .calculate {
    /deep/ .el-drawer__open .el-drawer.rtl {
      padding: 20px;
      width: 17% !important;
    }
  }
}
</style>
